import React, { useState, useId } from "react";
import CountrySelector from "../../../../util/forms/custom-intl-input/countryCode";
import { colors, font } from "../../../../styles/cssinjs/helpers/variables";
import { StyledError } from "../../../../styles/cssinjs/components/StyledForm";
export default function IntlInput({
  reqCountry = "us",
  errorStatus,
  errorMessage,
}) {
  const [selectedCountry, setSelectedCountry] = useState(reqCountry);
  const [mobileNumber, setmobileNumber] = useState("");
  const [isPhoneNumberInvalidate, setisPhoneNumberInvalidate] = useState();
  const isPhoneNumberEmptyWhenRequired = false;

  const [selectedDialCode, setDialCode] = useState("");
  const [selectedCountryCode, setCountryCode] = useState("");
  const errorID = useId();

  const isNullOrEmpty = (string) => {
    let str = string;
    try {
      if (str) {
        if (typeof str !== "undefined" && typeof str === "string")
          str = str.trim().toLowerCase();
        if (
          typeof str === "object" &&
          Object.keys(JSON.parse(str)).length === 0
        )
          str = "";
        if (str !== "" && str !== "null" && str !== "undefined") return false;
      }
    } catch (e) {
      return false;
    }
    return true;
  };

  const classToBeAdded = (field) => {
    let className = "";
    if (
      typeof document !== "undefined" &&
      document.activeElement &&
      document.activeElement.tagName === "INPUT" &&
      field.label === "mobile" &&
      document.activeElement.id === "phoneNo-req"
    ) {
      className += "active";
    } else {
      className = className.replace("active", "");
    }
    if (field.label === "mobile" && !isNullOrEmpty(mobileNumber)) {
      className += " has-val ";
    }
    if (!field.isRequired) {
      className += " label-optional ";
    }
    if (field.label === "mobile" && !isPhoneNumberInvalidate) {
      className += " warning ";
    }
    if (field.label === "mobile" && isPhoneNumberEmptyWhenRequired) {
      className += " error ";
    }

    return className.trim();
  };

  const countryCodeUpdated = (
    selectedCountryObj,
    number,
    nonFormattedNumber,
    isValid
  ) => {
    setSelectedCountry(selectedCountryObj.iso2);
    setmobileNumber(number);
    setisPhoneNumberInvalidate(isValid);
    // console.log(selectedCountryObj, number, nonFormattedNumber, isValid);
  };

  const onPhoneNumberBlur = (value, selectedCountry, isValid) => {
    setisPhoneNumberInvalidate(isValid);
    setCountryCode(selectedCountry.iso2);
    setDialCode(selectedCountry.dialCode);
    // console.log(value, selectedCountry, isValid);
  };

  const onPhoneNumberUpdate = (
    nonFormattedNumber,
    formattedNumber,
    selectedCountryData,
    isValid
  ) => {
    setmobileNumber(formattedNumber);
    setisPhoneNumberInvalidate(isValid);
    // console.log(
    //   nonFormattedNumber,
    //   formattedNumber,
    //   selectedCountryData,
    //   isValid
    // );
  };

  return (
    <div>
      <CountrySelector
        nationalMode={true}
        value={mobileNumber}
        selectedCountryCode={selectedCountry}
        field={{ label: "mobile" }}
        countryCodeUpdated={countryCodeUpdated}
        onPhoneNumberBlur={onPhoneNumberBlur}
        onPhoneNumberUpdate={onPhoneNumberUpdate}
        classList={classToBeAdded({ label: "mobile" })}
        className={`${errorStatus ? `error` : ``} intl-dropdown-wrap`}
        isPhoneNumberEmptyWhenRequired={isPhoneNumberEmptyWhenRequired}
      />
      <input type="hidden" name="dialCode" value={selectedDialCode} />
      <input type="hidden" name="countryCode" value={selectedCountryCode} />
      {errorStatus && <StyledError id={errorID}>{errorMessage}</StyledError>}
      <style jsx>{`
        div {
          position: relative;
          margin-bottom: 8px;
        }
        .intl-dropdown-wrap:global(div:focus:not(.error)) {
          border-bottom-color: ${colors.derived.brand};
          font-size: ${font.size.sm[4]};
        }
        .intl-dropdown-wrap:global(.error) {
          border-bottom-color: ${colors.derived.error};
        }
      `}</style>
    </div>
  );
}
